import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    // فقط عند تغيير الصفحة فعلاً
    if (prevPathname.current === pathname) return;
    prevPathname.current = pathname;

    // استخدام requestAnimationFrame لضمان تنفيذه بعد اكتمال الرسم
    requestAnimationFrame(() => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      } catch {
        // fallback للمتصفحات القديمة
        window.scrollTo(0, 0);
      }
    });
  }, [pathname]);

  return null;
}